import Accordion from '@components/Accordion';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

interface Props {
    agreed: boolean;
    onAgreedChange: (value: boolean) => void;
}

function OrderAgreements({ agreed, onAgreedChange }: Props) {
    const { t } = useTranslation('gift');
    const termCategories = useTermCategories('GIFT');

    return (
        <Container>
            <Accordion
                initialOpen
                title={(
                    <Checkbox isChecked={agreed}
                        toggleCheckbox={() => onAgreedChange(!agreed)}>
                        <Text size='body-short' fontWeight='medium' color={colors.gray8}>
                            {t('giftOrder.agreeTerms')}
                        </Text>
                    </Checkbox>
                )}>
                <Column fullWidth spacing={1}>
                    {termCategories.map((category) => (
                        <Link key={category.id}
                            activityName='TermDetailActivity'
                            activityParams={{ termCategoryId: category.id }}
                            css={css`text-decoration: none; width: 100%;`}>
                            <Row fullWidth justify='space-between' align='center' css={rowCss}>
                                <Text size='body-short' color={colors.textSecondary}>{category.title}</Text>
                                <Text size='body-long' fontWeight='bold' color={colors.gray6}
                                    css={css`text-decoration: underline;`}>
                                    {t('giftOrder.viewDetail')}
                                </Text>
                            </Row>
                        </Link>
                    ))}
                </Column>
            </Accordion>
        </Container>
    );
}

const Container = styled.section`
    width: 100%;
`;

const rowCss = css`
    padding: 10px 0;
`;

export default OrderAgreements;
